// utils/taskDisplay.js
//
// Staff and Technician create tasks from Category + Subcategory only -- no
// Title/Description input -- so tasks.title / tasks.description are NULL for
// those tasks (backend: services/taskCreationService.js#isTitlelessTaskCreator).
// Every screen that shows a task title uses taskDisplayTitle(), which falls
// back to the task's real structured data, "Category - Subcategory".
// Display-only: never sent back to the API as a title.

// Roles whose create forms have no Title/Description fields.
export const TITLELESS_TASK_ROLES = new Set(["staff", "technician"]);

export const isTitlelessTaskRole = (role) =>
  TITLELESS_TASK_ROLES.has(String(role || "").trim().toLowerCase());

const clean = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "object") return clean(value.name);
  const text = String(value).trim();
  return text === "null" || text === "undefined" ? "" : text;
};

export function taskCategoryLabel(task) {
  const t = task || {};
  const category = clean(t.category_name) || clean(t.category);
  const subCategory = clean(t.sub_category_name) || clean(t.subcategory_name) || clean(t.sub_category);
  return [category, subCategory].filter(Boolean).join(" - ");
}

// Title, else "Category - Subcategory", else "Task #id", else "".
export function taskDisplayTitle(task) {
  const t = task || {};
  const title = clean(t.title);
  if (title) return title;
  const label = taskCategoryLabel(t);
  if (label) return label;
  const id = t.id ?? t.task_id;
  return id !== null && id !== undefined && id !== "" ? `Task #${id}` : "";
}

// Description text, or "" when there is none (NULL/blank) -- callers hide
// the section or show "—", never "null"/"Not specified".
export function taskDescriptionText(task) {
  return clean((task || {}).description);
}
